import { useEffect } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { MacroPlanStepFromValue } from '../../../MacroPlanStep.settings';
import { calculateSugarFromCarbs } from '../../../../../../../../shared/utils/mealUtils';

export const useTotalSugar = (nameIndex: number) => {
  const { control, setValue } = useFormContext<MacroPlanStepFromValue>();

  const totalCarbs = useWatch({ control, name: `mealPlans.${nameIndex}.total.carbs` });

  useEffect(() => {
    const sugarTotal = calculateSugarFromCarbs(totalCarbs);

    setValue(`mealPlans.${nameIndex}.sugarTotal`, sugarTotal);
  }, [totalCarbs]);
};
